/**
 * One line per rated side, read from the finished narratives (the same text the
 * doctor pastes), so the at-a-glance summary can never disagree with the report.
 */
export interface RatingLine { label: string; wpi: number }

export function ratingSummary(narratives: string[]): RatingLine[] {
  const out: RatingLine[] = [];
  for (const n of narratives) {
    const title = n.match(/^<b><u>([^<]+?):?<\/u><\/b>/)?.[1] ?? n.match(/^((?:Right|Left) Grip Strength):/)?.[1];
    if (!title) continue;
    const wpis = Array.from(n.matchAll(/(\d+)% (?:WPI|whole person impairment)\b/gi)).map((m) => Number(m[1]));
    // "RIGHT SHOULDER" -> "Right Shoulder", but keep acronyms like TKA.
    const label = title.split(' ').map((w) => (/^[A-Z]{2,4}$/.test(w) && !/^(LEFT|HAND|KNEE|HIP)$/.test(w)
      ? w : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())).join(' ');
    out.push({ label, wpi: wpis.length ? wpis[wpis.length - 1] : 0 });
  }
  return out;
}
